import { DashboardItemActionButtons } from ".";
import { IAutomationObject } from "../../automationObjects";
import { AutomationObjectCard } from "../../automationObjects/components/Grid/AutomationObjectCard";
import { IDashboardCollection } from "./types";

const DashboardItem = (props: { app: IAutomationObject, edit: boolean, dashboard: IDashboardCollection, onItemRemoved: () => void }) => {

    const { app, edit, dashboard } = props;
    const aBs = edit ? <DashboardItemActionButtons onItemRemoved={props.onItemRemoved} app={app} dashboard={dashboard}></DashboardItemActionButtons> : <></>;

    return (
        <>
            {app && <AutomationObjectCard additionalProps={{ actionButtons: aBs }} item={app}></AutomationObjectCard>}
        </>
    )
}

export default DashboardItem;